import script from "./PaActionBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaActionBar.vue?vue&type=script&setup=true&lang=ts"

import "./PaActionBar.vue?vue&type=style&index=0&id=93022106&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93022106"]])

export default __exports__